import { useState, useEffect, useRef } from "react";
import toast from "react-hot-toast";
import { fetch } from "../../api-wrapper";

const useLock = (objectId, data, callback, pollInterval = 10000) => {
  const [locked, setLocked] = useState(false);
  const toastShown = useRef(false);
  const pollRef = useRef(null);

  useEffect(() => {
    if (!objectId) return;

    let isActive = true;

    // --- Acquire lock ---
    const acquire = () => {
      fetch(
        "/locks",
        "POST",
        { object_id: objectId },
        (response) => {
          if (!response?.data || !isActive) return;
          const responseData = response.data;

          // Guard against missing data (e.g. unmount or invalid props) to avoid throw in LockWrapper
          if (!data?.t) return;

          if (!responseData.acquired && !toastShown.current) {
            toast(`${data.t.read("locked")} ${data.t.read("by")} ${responseData.by}`, { icon: "🔒" });
            toastShown.current = true;
          }

          if (callback && responseData.acquired && toastShown.current) {
            callback();
            toast.success(`${data.t.read("unlocked")}`, { icon: "🔓" });
          }

          if (!isActive) return;
          setLocked(!responseData.acquired);

          // Start polling only if lock is held by someone else
          if (!responseData.acquired) startPolling();
          else stopPolling(); // if we succeed, no need to poll anymore
        },
        (err) => console.error("Erreur lock:", err)
      );
    };

    // --- Release lock ---
    const releaseLock = () => {
      fetch(
        "/locks",
        "DELETE",
        { object_id: objectId },
        () => {},
        (err) => console.error("Erreur release:", err)
      );
      stopPolling();
    };

    const startPolling = () => {
      if (!pollRef.current) {
        pollRef.current = setInterval(acquire, pollInterval);
      }
    };

    const stopPolling = () => {
      if (pollRef.current) {
        clearInterval(pollRef.current);
        pollRef.current = null;
      }
    };

    acquire();
    window.addEventListener("beforeunload", releaseLock);

    return () => {
      isActive = false;
      stopPolling();
      releaseLock();
      window.removeEventListener("beforeunload", releaseLock);
    };
  }, [objectId, pollInterval]);

  return { locked };
};

export default useLock;
